import {
    FETCH_TRANSACTION_QUOTES,
    FETCH_TRANSACTION_QUOTES_FAILURE,
    FETCH_TRANSACTION_QUOTES_SUCCESS,
} from 'store/actions/types';

export const fetchTransactionQuotes = (payload) => {
    return {
        type: FETCH_TRANSACTION_QUOTES,
        payload: payload,
    };
};

export const fetchTransactionQuotesFailure = (error) => {
    return {
        type: FETCH_TRANSACTION_QUOTES_FAILURE,
        error: error,
    };
};

export const fetchTransactionQuotesSuccess = (response) => {
    return {
        type: FETCH_TRANSACTION_QUOTES_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/transactions/fetchTransactions.js